export const FAQs = {
    en: {
      buy: {
        featured: [
          {
            id: 'buy0',
            q: 'How can I see a car before buying it?',
            a: 'You can view a car using our 360-degree digital photography, which allows you to see the car and inspect it from every angle, inside and out. You’ll be able to see the car’s condition, key features and any imperfections.\n\n\nYou can also view the car during your home visit, when you book our home test-drive option. During the visit you’ll be able to get an in person experience, and our Experience Specialist will ride along to answer all your inquiries and help you make the right decision.',
          },
          {
            id: 'buy3',
            q: 'Can I negotiate the price of Sylndr cars?',
            a: 'All car prices at Sylndr are fixed and non-negotiable. We do not believe in offering different value to different customers based on their negotiation skills, and hence our fixed price assurance saves you from the unnecessary loop of negotiations and haggling and ensures you get the best deal upfront, right away. We use pricing data from the market and the detailed inspection report that we conduct on each car to arrive at a fair and fixed price so you can buy your favorite Sylndr Certified car with complete confidence.',
          },
          {
            id: 'buy10',
            q: 'What is the form of ownership transfer?',
            a: 'After completing the full payment, we will provide you with a Traffic Authority invoice for you to submit at the Traffic Authority to transfer the license under your name. In order to provide you with the best experience, we made sure to register Sylndr at the Traffic Authority as an authorized dealer, in order to avoid asking you to visit the Public Notary Office to complete the ownership transfer.',
          },
          {
            id: 'buy20',
            q: 'How can I apply for financing?',
            a: 'You can apply online on the checkout page after you have reserved your car. We have partnered with several financing institutions in order to provide you with flexible financing options. You will also be able to calculate your expected monthly installments online, depending on your preferred tenor, downpayment, and your choice of a plan type (with car sale ban, or without a car sale ban). Once you complete your online application, our team will process your application with the financing institutions and we will contact you to update you on the progress and status of your application.',
          },
          {
            id: 'buy27',
            q: 'What is Sylndr’s 7-Day Money Back Guarantee?',
            a: 'Our 7-Days Money Back Guarantee is Sylndr’s way to make sure that you’re completely satisfied and confident of your purchase. In case you have second thoughts regarding the Sylndr Certified car that you purchased, you can return it for 100% refund and no questions will asked from our side. You just need to make sure that your return is eligible under our fair usage policy (below):\n\n1) A return request must be placed within the first 7 days from the date of delivery of the car.\n2) The car must not have run more than 250 KMs\n3) No external maintenance, repair, scratches/dents and/or parts replacement work have been done during the 7 days validity period of the money back guarantee\nIf your purchased Sylndr Certified car meets the listed eligibility criteria, you can avail a 100% refund under our 7-Day Money Back Guarantee.\n\n To proceed, call 17188 or write to us at contact@sylndr.com, and drop your car at our Sylndr Hub.',
          },
          {
            id: 'buy28',
            q: 'What is Sylndr’s 90 days Warranty?',
            a: 'Sylndr 90-Day Warranty\nAll Sylndr Certified cars come with a 90-Day Warranty to ensure any unforeseen mechanical faults do not affect your ownership experience. The warranty provides a Comprehensive Coverage that is Applicable for 90 days or up to 5,000 kms (whichever occurs first) from the date of purchase.\n\nClaiming your Sylndr Warranty\nIn order to claim your coverage, call our support team on 17188 through the week (except Fridays and Saturdays) between 10 am to 5 pm or write to us at contact@sylndr.com.\n\nNote: Please make sure to raise your query via the above helpline channels within 3 working days from the occurrence of the claim event, failing to do so would render the claim as invalid. Please mail with the registration number of the car in the subject line.\n\nConditions for Validity of Warranty\nThe warranty for your Sylndr Certified car will be considered void and will not be reinstated under the following conditions :\n\n- Car is not serviced in a timely manner: \nThe car is ‘not’ serviced in a timely manner by the customer as per the which means that it has to occur in-line with the manufacturer’s guidelines. All services and tests must be carried out at an authorized service center. You need to keep a copy of all service/maintenance records of the car.\nNote: Service means and consists of changing engine oil, oil filter, checking oil levels in gearbox and differential, coolant level and top up where necessary.\n\n Changes in car condition:\nIf the car undergoes significant change in condition that affects performance of the car or any physical damage, the warranty will be considered void.\nPlease refer to the Warranty TnC booklet provided during purchase for more details\n\n- Sale to Another Person:\nThe warranty on your Sylndr Certified car is non-transferable and will be considered void if the car is sold to another person prior to the expiration of the warranty coverage.\n\n- Commercial Use:\nThe warranty on your Sylndr Certified car will be considered void if the car is used as a taxi or fleet test drive car or other prohibited commercial purposes where the car can be used by multiple drivers.\n\n\nWarranty Exclusions\n\n- External Repairs/Damages: Sylndr is not liable for any reimbursements for any external repairs/replacements done by you or for any other accidental damages after the delivery of the car.\n- OEM Warranty Transfer: Any OEM warranty (if valid on the car) gets transferred to the car along with the Sylndr warranty and must be availed in accordance with the terms and condition of the concerned OEM warranty.\n\nWarranty Coverage\nTo see a detailed overview of the different parts covered, take a look at our Warranty Coverage Handbook (attached below).',
          },
        ],
        topics: [
          {
            id: 0,
            topic: 'General',
            questions: [
              {
                id: 0,
                q: 'How can I see a car before buying it?',
                a: 'You can view a car using our 360-degree digital photography, which allows you to see the car and inspect it from every angle, inside and out. You’ll be able to see the car’s condition, key features and any imperfections.\n\n\nYou can also view the car during your home visit, when you book our home test-drive option. During the visit you’ll be able to get an in person experience, and our Experience Specialist will ride along to answer all your inquiries and help you make the right decision.',
              },
              {
                id: 1,
                q: 'How can I see any imperfections on a car before I complete my purchase?',
                a: 'If a car has imperfections, you can see them on our website by clicking on Conditions on the car profile page. We always highlight the imperfections that are visible through photography. There may be some additional wear and tear that isn’t always visible in the images, so we may not be able to display and call out every imperfection on a car.\n\n You’ll also be able to check the imperfections during your test drive visit at our Sylndr Hub or at your home.',
              },
              {
                id: 2,
                q: 'What if my car isn’t in the condition I expected?',
                a: 'If you’re not completely happy with the condition of the car when it’s delivered you can return it using our 7-Days Money Back Guarantee',
              },
              {
                id: 3,
                q: 'Can I negotiate the price of Sylndr cars?',
                a: 'All car prices at Sylndr are fixed and non-negotiable. We do not believe in offering different value to different customers based on their negotiation skills, and hence our fixed price assurance saves you from the unnecessary loop of negotiations and haggling and ensures you get the best deal upfront, right away. We use pricing data from the market and the detailed inspection report that we conduct on each car to arrive at a fair and fixed price so you can buy your favorite Sylndr Certified car with complete confidence.',
              },
              {
                id: 4,
                q: 'How do I know I’m getting a fair price?',
                a: '-Every Sylndr Certified car is carefully handpicked, where each car must pass our strict two hundred-point quality inspection in order to assure the car being in excellent driving condition.\n - We rely on pricing data from the market and the detailed inspection report, which ensures that our customers get a fair and fixed price without any negotiations and haggles. \n- If you’re not completely in love with your Sylndr Certified car, you can simply return it for a 100% refund no-questions-asked with our 7-Day Money Back Guarantee. \n- Our 90 days Warranty brings peace of mind by making every drive, a worry-free drive.',
              },
            ],
          },
          {
            id: 1,
            topic: 'Bookings and Test Drives',
            questions: [
              {
                id: 5,
                q: "How do I book a visit to see a car I'm interested in?",
                a: 'To book a visit, simply browse our website and find the car you\'re interested in. Once you\'ve found it, click on the "Book Visit". You will then be directed to fill in your details and select a convenient date and time to visit our showroom.',
              },
              {
                id: 6,
                q: 'What information do I need to provide when booking a visit?',
                a: 'When booking a visit, you will need to provide your contact details, including your phone number, and select a preferred date and time for your visit. This information helps us to prepare for your visit and ensure the car is available for you to see.',
              },
              {
                id: 7,
                q: 'What happens after I book a visit to see a car?',
                a: 'After booking a visit, you should come to our showroom at the scheduled date and time. You will have the opportunity to view the car and take it for a test drive. If you like the car and wish to reserve it, you can proceed with the reservation process.',
              },
              {
                id: 8,
                q: 'How can I reserve a car after my visit?',
                a: 'If you decide to reserve the car after your visit, inform the salesman assisting you. The salesman will send a payment link to the phone number you provided during booking. You need to pay a reservation fee of 10,000 EGP to reserve the car for you (100% refundable). The reservation is valid for 24 hours, during which you must complete the purchase.',
              },
              {
                id: 9,
                q: "What if I don't complete the purchase within 24 hours after reserving a car?",
                a: "If you do not complete the purchase within 24 hours, the reservation will expire, and the car will become available for other customers. It's important to finalize your purchase within this period to ensure the car remains reserved for you.",
              },
            ],
          },
          {
            id: 3,
            topic: 'Purchase and Delivery',
            questions: [
              {
                id: 10,
                q: 'What is the form of ownership transfer?',
                a: 'After completing the full payment, we will provide you with a Traffic Authority invoice for you to submit at the Traffic Authority to transfer the license under your name. In order to provide you with the best experience, we made sure to register Sylndr at the Traffic Authority as an authorized dealer, in order to avoid asking you to visit the Public Notary Office to complete the ownership transfer.',
              },
              {
                id: 11,
                q: 'Is ownership transfer cost included in the car price?',
                a: 'Yes, ownership transfer fees are included in the car price. Sylndr is registered as an authorized car dealership at the Traffic Authority, and hence a Traffic Authority invoice will provided at the time of purchase, which you will need to submit to the Traffic Authority to transfer the license under your name.',
              },
              {
                id: 12,
                q: 'Can I pay in cash?',
                a: 'No, we only accept bank deposits, bank transfers and bank cheques as payment methods',
              },
              {
                id: 13,
                q: 'Do I need to pay any transaction charges while making payments?',
                a: 'You may be charged additional transaction/convenience fees depending on the payment method/bank you use. That said, you won’t have to pay any charges to Sylndr when reserving your car.',
              },
              {
                id: 14,
                q: 'Can I request a doorstep delivery of my Sylndr Certified car?',
                a: 'Yes, we can deliver your Sylndr Certified car right at your doorstep. However, doorstep deliveries of Sylndr cars are subject to the availability of a delivery agent. Kindly pre-book your slot for delivery when making the full payment against your purchase.',
              },
            ],
          },
          {
            id: 4,
            topic: 'Trade-ins',
            questions: [
              {
                id: 15,
                q: 'Which cars does Sylndr accept for trade-in?',
                a: 'We aim to accept all cars through our trade-in program but it depends on the condition of the vehicle. The majority of our cars that we trade-in are under 10 years old and have less than 120,000 km of mileage. We don’t buy cars that have major accidents, mechanical or electrical faults, or have been modified.',
              },
              {
                id: 16,
                q: 'How does trade-in work?',
                a: 'Once you have picked your preferred car you can request a trade-in; we will perform our inspection process and provide a fair price depending on the car’s condition and market value. If approved by the customer the car’s value will be deducted from the purchase price of your new Sylndr Certified car.',
              },
              {
                id: 17,
                q: 'When will I give you my trade-in car?',
                a: 'We’ll take your current car off your hands at the same time you receive your Sylndr Certified car.',
              },
              {
                id: 18,
                q: 'Can I trade-in my current car if I have outstanding finance?',
                a: 'Yes, you can trade-in your current car if it has outstanding finance. We’ll give you a valuation based on your car’s current condition and compare this against the amount of outstanding finance you have on your agreement.',
              },
              {
                id: 19,
                q: 'Can I negotiate the price Sylndr offers on my trade-in?',
                a: 'You can’t negotiate on the price of your trade-in car. We offer a transparent and haggle-free experience for our customers, so you can be sure that the valuation you receive is the best offer we can make.',
              },
            ],
          },
          {
            id: 5,
            topic: 'Car Financing and Insurance',
            questions: [
              {
                id: 20,
                q: 'How can I apply for financing?',
                a: 'You can apply online on the checkout page after you have reserved your car. We have partnered with several financing institutions in order to provide you with flexible financing options. You will also be able to calculate your expected monthly installments online, depending on your preferred tenor, downpayment, and your choice of a plan type (with car sale ban, or without a car sale ban). Once you complete your online application, our team will process your application with the financing institutions and we will contact you to update you on the progress and status of your application.',
              },
              {
                id: 21,
                q: 'How much of the car’s price can I finance?',
                a: 'You can finance up to 90% of your selected Sylndr Certified car; this depends on your loan eligibility determined by our financing partners.Once you provide the required documents we will provide you with feedback depending on your car choice and credit profile.',
              },
              {
                id: 22,
                q: 'What if I take a loan and return my car back in the 7-day guarantee period?',
                a: 'No problem, if you are not 100% satisfied with your purchase you can still return your vehicle under the 7 Days money back guarantee even when financed, we will still provide a 100% refund. Please refer to our 7 Days Money Back Policy.',
              },
              {
                id: 23,
                q: 'What documents are required to avail car financing?',
                a: 'You will be required to upload your National ID and fill out our online application. Once we share your application with our financing partners and get their approval, you will be required to submit few other documents to proceed with the loan agreement.',
              },
              {
                id: 24,
                q: 'Can I arrange for financing by myself for a car purchased at Sylndr?',
                a: 'We can only accept full payments by the customers, or financed through one of our financing partners.',
              },
            ],
          },
          {
            id: 6,
            topic: 'Sylndr Certified',
            questions: [
              {
                id: 25,
                q: 'What is Sylndr Certified?',
                a: 'Sylndr Certified is our promise to deliver you a high-quality car that makes your buying experience completely convenient and reliable. Every Sylndr Certified car has passed our strict 200-point quality inspection after being fully reconditioned. Our Sylndr Certified car also comes with a 6-Months Warranty, that makes your drive worry-free. And if you don’t like your car, you can simply return-it for 100% refund (no questions asked!) under our 7-days Money Back Guarantee.',
              },
              {
                id: 26,
                q: 'What is Sylndr’s 200 Point Inspection?',
                a: 'All our listed cars undergo a 200-point inspection evaluation in order to become a Sylndr Certified car. The inspection process evaluates the following:\n- Technical: Checks all mechanical components of the car; from engine, transmission, suspension, braking system to AC and cooling systems.\n- Exterior: Checks for dents, scratches, breaks, replaced parts and paint across the full body of the car.\n- Interior: Checks the condition of the seats, upholstery, buttons, sound system, and other functionalities.',
              },
              {
                id: 27,
                q: 'What is Sylndr’s 7-Day Money Back Guarantee?',
                a: 'Our 7-Days Money Back Guarantee is Sylndr’s way to make sure that you’re completely satisfied and confident of your purchase. In case you have second thoughts regarding the Sylndr Certified car that you purchased, you can return it for 100% refund and no questions will asked from our side. You just need to make sure that your return is eligible under our fair usage policy (below):\n\n1) A return request must be placed within the first 7 days from the date of delivery of the car.\n2) The car must not have run more than 250 KMs\n3) No external maintenance, repair, scratches/dents and/or parts replacement work have been done during the 7 days validity period of the money back guarantee\nIf your purchased Sylndr Certified car meets the listed eligibility criteria, you can avail a 100% refund under our 7-Day Money Back Guarantee.\n\n To proceed, call 17188 or write to us at contact@sylndr.com, and drop your car at our Sylndr Hub.',
              },
              {
                id: 28,
                q: 'What is Sylndr’s 90 days Warranty?',
                a: 'Sylndr 90-Day Warranty\nAll Sylndr Certified cars come with a 90-Day Warranty to ensure any unforeseen mechanical faults do not affect your ownership experience. The warranty provides a Comprehensive Coverage that is Applicable for 90 days or up to 5,000 kms (whichever occurs first) from the date of purchase.\n\nClaiming your Sylndr Warranty\nIn order to claim your coverage, call our support team on 17188 through the week (except Fridays and Saturdays) between 10 am to 5 pm or write to us at contact@sylndr.com.\n\nNote: Please make sure to raise your query via the above helpline channels within 3 working days from the occurrence of the claim event, failing to do so would render the claim as invalid. Please mail with the registration number of the car in the subject line.\n\nConditions for Validity of Warranty\nThe warranty for your Sylndr Certified car will be considered void and will not be reinstated under the following conditions :\n\n- Car is not serviced in a timely manner: \nThe car is ‘not’ serviced in a timely manner by the customer as per the which means that it has to occur in-line with the manufacturer’s guidelines. All services and tests must be carried out at an authorized service center. You need to keep a copy of all service/maintenance records of the car.\nNote: Service means and consists of changing engine oil, oil filter, checking oil levels in gearbox and differential, coolant level and top up where necessary.\n\n Changes in car condition:\nIf the car undergoes significant change in condition that affects performance of the car or any physical damage, the warranty will be considered void.\nPlease refer to the Warranty TnC booklet provided during purchase for more details\n\n- Sale to Another Person:\nThe warranty on your Sylndr Certified car is non-transferable and will be considered void if the car is sold to another person prior to the expiration of the warranty coverage.\n\n- Commercial Use:\nThe warranty on your Sylndr Certified car will be considered void if the car is used as a taxi or fleet test drive car or other prohibited commercial purposes where the car can be used by multiple drivers.\n\n\nWarranty Exclusions\n\n- External Repairs/Damages: Sylndr is not liable for any reimbursements for any external repairs/replacements done by you or for any other accidental damages after the delivery of the car.\n- OEM Warranty Transfer: Any OEM warranty (if valid on the car) gets transferred to the car along with the Sylndr warranty and must be availed in accordance with the terms and condition of the concerned OEM warranty.\n\nWarranty Coverage\nTo see a detailed overview of the different parts covered, take a look at our Warranty Coverage Handbook (attached below).',
              },
            ],
          },
        ],
      },
      sell: {
        featured: [
          {
            id: 'sell0',
            q: 'Who is the buyer?',
            a: 'Sylndr is the direct buyer of the car. Our team helps you go through a seamless experience to sell your car within 48 hours.',
          },
          {
            id: 'sell1',
            q: 'Which Cars does Sylndr Buy?',
            a:
              'Sylndr has a shopping list that gets updated periodically:\n' +
              '\n' +
              '- Manufactured from 2010 to date\n' +
              '- Mileage up to 180,000 kilometers\n' +
              '- Registered in your name\n' +
              '- We can also buy cars with a Power of Attorney if you are the direct owner\n' +
              '- Private passenger cars only; we do not buy commercial cars\n' +
              '- We don’t buy hybrid, electric, or natural gas cars\n' +
              '- Must have a valid car license',
          },
          {
            id: 'sell',
            q: 'Am I committed to selling my car to Sylndr after inspection?',
            a: 'No, you are not committed or obliged to sell your car to Sylndr; our priority is to make sure you feel confident and happy with finalizing the transaction with Sylndr.',
          },
          {
            id: 'sell4',
            q: 'What information is needed to get my offer communicated?',
            a: "We will need to go through a few steps to help us price your car:\n1) Licence & Car specifications\n2) Perform our inspection, including a test drive, to evaluate the car's condition\n3) Photos of the car\nThis information helps our pricing team provide the best offer",
          },
          {
            id: 'sell6',
            q: 'Is the doorstep inspection and valuation free of cost?',
            a: 'Yes its 100% free of charge, at no point during our process are you obliged to pay for anything. In case of any conflict, kindly call our hotline 17188. ',
          },
          {
            id: 'sell17',
            q: 'What if I change my mind about selling after the valuation?',
            a: 'We aim to provide a seamless experience; if you do not wish to proceed with the sale of your car to Sylndr, you may absolutely do so. Our priority is you go through a great experience.',
          },
          {
            id: 'sell24',
            q: 'How does the ownership transfer take place?',
            a: 'We do it in 4 easy steps:\n1) Sign Sylndr’s purchase contract\n2) We proceed with payment (Cheque or bank transfer)\n3) We collect the car from your side\n4) Meet at Notary to finalize ownership transfer',
          },
        ],
        topics: [
          {
            id: 0,
            topic: 'General',
            questions: [
              {
                id: 0,
                q: 'Who is the buyer?',
                a: 'Sylndr is the direct buyer of the car. Our team helps you go through a seamless experience to sell your car within 48 hours.',
              },
              {
                id: 1,
                q: 'Which Cars does Sylndr Buy?',
                a:
                  'Sylndr has a shopping list that gets updated periodically:\n' +
                  '\n' +
                  '- Manufactured from 2010 to date\n' +
                  '- Mileage up to 180,000 kilometers\n' +
                  '- Registered in your name\n' +
                  '- We can also buy cars with a Power of Attorney if you are the direct owner\n' +
                  '- Private passenger cars only; we do not buy commercial cars\n' +
                  '- We don’t buy hybrid, electric, or natural gas cars\n' +
                  '- Must have a valid car license',
              },
              {
                id: 2,
                q: 'Am I committed to selling my car to Sylndr after inspection?',
                a: 'No, you are not committed or obliged to sell your car to Sylndr; our priority is to make sure you feel confident and happy with finalizing the transaction with Sylndr.',
              },
              {
                id: 3,
                q: 'Can you purchase my car if I have a loan or outstanding finance?',
                a: "Yes, we can. Sylndr will pay you 50% of the car price upfront, and the remaining will be paid in full after the car is uploaded\nYou need to provide an official power of attorney\nWe offer potential customers about a month's grace period",
              },
              {
                id: 4,
                q: 'What information is needed to get my offer communicated?',
                a: "We will need to go through a few steps to help us price your car:\n1) Licence & Car specifications\n2) Perform our inspection, including a test drive, to evaluate the car's condition\n3) Photos of the car\nThis information helps our pricing team provide the best offer",
              },
            ],
          },
          {
            id: 1,
            topic: 'Booking an Appointment',
            questions: [
              {
                id: 5,
                q: 'Where can I book my inspection visit?',
                a: 'As you wish! You can visit us at Sylndr Hub, or we can come to you at a place of your choosing.',
              },
              {
                id: 6,
                q: 'Is the doorstep inspection and valuation free of cost?',
                a: "Yes, it's 100% free of charge. At no point during our process are you obliged to pay for anything.",
              },
              {
                id: 7,
                q: 'My car is not listed in Sylndr form. What should I do?',
                a: 'If your car is not listed, it may not meet Sylndr current shopping criteria. We update our criteria frequently, so please visit our website to view our updated shopping list.',
              },
              {
                id: 8,
                q: 'Can I cancel or reschedule my car’s inspection to another date?',
                a: 'If the timing is not suitable, feel free to reach out to our customer support team and reschedule your appointment or cancel it. Please call 17188, and our customer support team will be more than happy to help.',
              },
            ],
          },
          {
            id: 2,
            topic: 'Inspection Visit',
            questions: [
              {
                id: 9,
                q: 'Who is going to inspect my car?',
                a: 'Our own team of Sylndr Technical Experts will be performing the inspection. Our team consists of experienced automotive engineers using the most updated technology and instruments to build our detailed inspection report.',
              },
              {
                id: 10,
                q: 'What documents will I need for my car inspection?',
                a: 'We only need a valid license at this stage; we will need additional documents once you have accepted our offer and then proceed with the transaction.',
              },
              {
                id: 11,
                q: 'Will my car’s inspection report be shared with me?',
                a: 'No, the results of the inspection report are not communicated, as they’re only developed for internal use by the Sylndr team.',
              },
              {
                id: 12,
                q: 'What will be checked during my car’s inspection?',
                a: "We perform a detailed assessment covering more than 200 points, including the car’s exterior, interior, and reliability. Following the inspection, our Sylndr Technical Experts perform a test drive to help assess the car's condition, in addition to taking photos of the car and license.",
              },
              {
                id: 13,
                q: 'What happens after the inspection is completed?',
                a: 'Our Technical Experts will finalize the report and share it with our Pricing team. Within 24 hours, we will get back to you with an offer.',
              },
            ],
          },
          {
            id: 3,
            topic: 'Valuation',
            questions: [
              {
                id: 14,
                q: 'How does Sylndr guarantee the best price for my car?',
                a: 'At Sylndr, we believe you deserve a price for your car that truly values its condition. That is why, our Doorstep Evaluation makes it easy for you to get a great price and sell your car directly from the comfort of your home. This is possible by removing all middlemen from the selling process and reflecting those savings into providing a better purchasing price.',
              },
              {
                id: 15,
                q: 'How much time will the valuation take?',
                a: 'Our evaluation takes a maximum of 24 hours to be completed and communicated to you.',
              },
              {
                id: 16,
                q: 'Does my car’s valuation guarantee its sale?',
                a: 'The evaluation is there to help you find the true and fair price of your car, but it does not guarantee its sale to Sylndr; if the evaluation report does not pass our selection criteria, Unfortunately, we will not be able to purchase it.',
              },
              {
                id: 17,
                q: 'What if I change my mind about selling after the valuation?',
                a: 'We aim to provide a seamless experience; if you do not wish to proceed with the sale of your car to Sylndr, you may absolutely do so. Our priority is that you have a great experience.',
              },
              {
                id: 18,
                q: 'What is the validity of Sylndr’s offer?',
                a: 'We do not want you to be in a rush; our offer validity is 24 hours after offer communication and up to 350 KMS variance from our inspection visit. If you want to sell your car to Sylndr after 24 hours, you can still do so, but we will need to schedule a new inspection visit.',
              },
            ],
          },
          {
            id: 4,
            topic: 'Payment',
            questions: [
              {
                id: 20,
                q: 'How soon will I get the payment?',
                a: 'Instantly, after you sign the contract, you get the cheque or the amount transferred to your bank account.\nFor cheques, after presenting the cheque to your bank, normally it takes one to three working days for the money to reach the account (one day at the same bank, three days different banks).\nFor online transfers, the money reaches your account within one business day.\n',
              },
              {
                id: 21,
                q: 'What payment methods are available at Sylndr?',
                a: 'Bank Draft cheque, Normal cheque, or digital transfer to your bank account. We want to make sure to provide the most convenient method of payment.\n',
              },
              {
                id: 22,
                q: 'How long will it take for the payment to be transferred to my account?',
                a: 'For online transfers, the money reaches your account within one business day.',
              },
              {
                id: 23,
                q: 'Will the payment be made before or after the car is picked up by Sylndr?',
                a: 'The payment is made upon contract signature, but before going to the Public Notary to transfer ownership.',
              },
            ],
          },
          {
            id: 5,
            topic: 'Ownership Transfer and Handover',
            questions: [
              {
                id: 24,
                q: 'How does the ownership transfer take place?',
                a: 'We do it in 4 easy steps:\n1) Sign Sylndr’s purchase contract\n2) We proceed with payment (Cheque or bank transfer)\n3) We collect the car from your side\n4) Meet at Notary to finalize ownership transfer',
              },
              {
                id: 25,
                q: 'What do I need to bring with me when I drop off my car? ',
                a: 'We need the below requirements to be available during the car drop-off:\n1) Car keys, including spare key(s)\n2) Original license and POA, if available\n3) Original car warranty and maintenance receipts, if available \n4) Safety accessories, if available',
              },
              {
                id: 26,
                q: 'How long will it take for the ownership to be transferred from my name?',
                a: 'We facilitate the process of ownership transfer through the Notary; our transaction team will make sure you have a smooth and hassle-free process to finalize the purchase process.',
              },
              {
                id: 27,
                q: 'When do I need to hand over the car?',
                a: 'Once you have signed Sylndr’s purchase contract and have received the full payment for your car.',
              },
              {
                id: 28,
                q: 'How can I contact Sylndr for any post-sale queries?',
                a: 'Please feel free to reach out to our customer support team on 17188, we are more than happy to answer all your inquiries.',
              },
            ],
          },
        ],
      },
    },
    ar: {
      buy: {
        featured: [
          {
            id: 'buy0',
            q: 'ازاي اقدر أشوف العربية قبل ما اشتريها؟',
            a: 'ممكن تشوف العربية أونلاين من خلال صور بانورامية 360 درجة عالية الجودة هتخليك تلف حوالين العربية وتعاين كل جزء فيها جوه وبره وتقييم حالتها قبل ما تشرتريها.\n\nممكن بردو تشوف العربية لو حجزت خدمة إختبار القيادة من تحت البيت. هتقدر تعاينها على الطبيعة، وتسوقها وتقيم تجربتك. في الحالة ديه هيبقي فيه من طرفنا خبير متخصص علشان يجاوب على كل أسئلتك ويساعدك تاخد القرار الصح',
          },
          {
            id: 'buy3',
            q: 'هل ممكن أتفاوض في سعر عربيات سيلندر؟',
            a: 'سعر العربيات في سيلندر ثابت وغير قابل للتفاوض. إحنا مقتنعين بآن جميع عملائنا من حقهم الحصول على سعر ثابت طبقًا لحالة العربية بغض النظر عن مهارتهم التفاوضية أو حاجتهم للعربية، وأن من حق كل عميل لسيلندر أنه يحصل مباشرة على أفضل سعر للعربية!\n\nاحنا بنحدد سعر كل عربية اعتمادا على بيانات أسعار السوق ونتائج تقرير الفحص اللى بنجريه علشان نوصل لسعر عادل. وده بيخلي العميل يشتري العربية اللى هو عايزها وهو مطمن بأن ده أفضل سعر مقابل القيمة، لإنها معتمدة من سيلندر.',
          },
          {
            id: 'buy10',
            q: 'إيه هو شكل نقل الملكية؟',
            a: 'بعد دفع تمن العربية، هنوفر لك جواب لإدارة المرور لنقل ملكية العربية باسمك. ولتسهيل الإجراءات عليك، إحنا مسجلين سيلندر في إدارة المرور كموزع معتمد للعربيات وده بيوفر عليك مشوار نقل الملكية في مكتب الشهر العقاري.',
          },
          {
            id: 'buy20',
            q: 'ازاي أقدر أقدم على تمويل؟',
            a: 'تقدر تقدم اونلاين على موقعنا بعد ما تحجز عربيتك. لدينا شراكات مع عدد من مؤسسات التمويل واللي بتوفر أكتر من نظام تمويل بصورة مرنة.\n\nقبل ما تقرر، هتقدر من خلال موقعنا تحدد المقدم اللى هتدفعه، ومدة النقسيط اللي تفضلها، وإذا كنت عايز إن العربية يكون عليها حظر بيع أو لأ، وببساطة هتعرف قيمة القسط الشهري اللى عليك. أول ما تخلص الإجراءات دي على الموقع، فريقنا هيدرس الملف مع مؤسسة التمويل، وهنتواصل معاك علشان نبلغك بتطور طلب التمويل.',
          },
          {
            id: 'buy27',
            q: 'إيه هي سياسة سيلندر لاسترداد الأموال خلال 7 أيام؟',
            a: 'ضمان استرداد الأموال لمدة 7 أيام هو التزام من سيلندر لعملاءنا إنهم ياخدوا وقتهم ويشوفوا إذا كانوا مبسوطين ومطمنين تماما بعد شراء العربية. لو شعروا بغير كده، بعد شراءهم عربية سيلندر المعتمدة من حقهم يرجعوا العربية ويستردوا فلوسهم بالكامل من غير ما نوجه لهم أي سؤال. كل اللى بنطلبه منهم هو إنهم يلتزموا بالشروط والإجراءات علشان عملية استرداد الأموال تتم وفقا لسياسة الاستخدام العادل والشروط هي كالتالي:\n1) لازم يقدم العميل طلب إرجاع العربية خلال أول 7 أيام من تاريخ تسلمها.\n2)أقصي كيلومترات عملتها العربية من تاريخ تسلمها ماتزيدش عن 250 كم.\n3) ما يكونش تم في العربية أي أعمال صيانة خارجية أو تصليح أو حصل للعربية خدوش أو كسر أو استبدال أجزاء خلال فترة صلاحية ال7 أيام لاسترداد الأموال.\n\nإذا كانت عربيتك المعتمدة من سيلندر مستوفيه المعايير اللي مكتوبة، فممكن تستفيد من ضمان استرداد 100٪ من تكلفة العربية بموجب سياسة استرداد الأموال لمدة 7 أيام. للمتابعة، اتصل بـينا على الرقم التالي: ١٧١٨٨ أو ابعتلنا إيميل على contact@sylndr.com، ووصل لنا عربيتك لمركز لسيلندر.',
          },
          {
            id: 'buy28',
            q: 'إيه هو ضمان ال٩٠ يوم من سيلندر؟',
            a: 'ضمان ال٩٠ يوم من سيلندر\nكل عربيات سيلندر المعتمدة مضمونة لمدة ٩٠ يوم علشان نوفر متعة قيادة العربية بدون أي أعطال ميكانيكية مفاجئة. الضمان بيكون لمدة 90 يوم أو 5000 كم (أيهما أقرب) من تاريخ شراء العربية.\n\nطلب ضمان سيلندر\nلو حصل أي حاجة وعايز تستفيد بالضمان، اتصل بفريق الدعم على ١٧١٨٨ خلال الأسبوع (ما عدة الجمعة والسبت) من الساعة 9 صباحا إلى الساعة 5 مساءً أو راسلنا على contact@sylndr.com.\n\nملاحظة: برجاء التأكد من ارسال استفسارك عبر قنوات خط المساعدة اللى فوق خلال 3 أيام عمل من وقوع العطل. عدم القيام بالإجراءات دي في مواعيدها مش هيتيح لك الاستفادة بالضمان. برجاء إرسال رقم تسجيل العربية على الميل في عنوان الرسالة.\n\nشروط صلاحية الضمان\nيعتبر الضمان الخاص بعربيتك المعتمدة من سيلندر باطل في حالة الشروط التالية:\n- لو صيانة العربية ما بتتعملش في الوقت المناسب:  لو العميل ما بيعملش الصيانة الدورية للعربية في الوقت المناسب وحسب إرشادات الشركة المصنعة للعربية. يجب على العميل القيام بكل خدمات الصيانة واختبارات العربية في مركز خدمة معتمد. لازم تحتفظ بنسخة من كل إجراءات الصيانة الدورية للعربية.\n\nملاحظة: صيانة العربية بتشمل، تغيير زيت الموتور، وفلتر الزيت، وفحص مستوى الزيت في علبة التروس ومراجعة التروس، ومستوى سائل التبريد، وتزويده عند الضرورة.\n\n- التغييرات في حالة العربية:  لو تم إجراء تغييرات كبيرة في حالة العربية بشكل يأثر على أداء العربية أو حصل أي ضرر للعربية، فبيتم إلغاء الضمان. لو عايز تعرف تفاصيل أكتر نرجو مراجعة كتيب ضمان اللي تم تسليمه مع شراء العربية.\n\n- البيع لشخص آخر: الضمان على عربيتك المعتمدة من سيلندرغير قابل للتحويل ويعتبر ملغي إذا تم بيع العربية لشخص آخر قبل انتهاء صلاحية تغطية الضمان.\n\n- إستخدام تجاري:  يعتبر الضمان على عربيتك المعتمدة من سيلندر ملغي إذا تم استخدام العربية كتاكسي أو عربية للتدريب على السواقة أو أي أغراض تجارية.\n\nاستثناءات الضمان\n- الإصلاحات / الأضرار الخارجية: سيلندر مش مسؤولة عن أي تعويضات أو عن أي إصلاحات خارجية / استبدال من قبلك أو عن أي أضرار جانبية بعد تسليم العربية.\n- نقل ضمان التوكيل: يتم نقل أي ضمان من التوكيل (إذا كان ساري) إلى العربية مع ضمان سيلندر ويتم الاستفادة منه حسب شروط وأحكام ضمان التوكيل.\n\nتغطية الضمان\nللاطلاع على نظرة عامة مفصلة عن الأجزاء اللى بيغطيها الضمان، نرجو قراءة دليل تغطية الضمان (مرفق).',
          },
        ],
        topics: [
          {
            id: 0,
            topic: 'عامة',
            questions: [
              {
                id: 0,
                q: 'ازاي اقدر أشوف العربية قبل ما اشتريها؟',
                a: 'ممكن تشوف العربية أونلاين من خلال صور بانورامية 360 درجة عالية الجودة هتخليك تلف حوالين العربية وتعاين كل جزء فيها جوه وبره وتقييم حالتها قبل ما تشرتريها.\n\nممكن بردو تشوف العربية لو حجزت خدمة إختبار القيادة من تحت البيت. هتقدر تعاينها على الطبيعة، وتسوقها وتقيم تجربتك. في الحالة ديه هيبقي فيه من طرفنا خبير متخصص علشان يجاوب على كل أسئلتك ويساعدك تاخد القرار الصح',
              },
              {
                id: 1,
                q: 'ازاي اقدر اعرف أي ملاحظات في العربية قبل ما اشتريها؟',
                a: 'احنا مهتمين بآننا نوفرلك تجربة فيها أكبر قدر من الشفافية، لذلك جميع الملاحظات الخاصة بالعربية هتكون مرصودة من خلال الصور على موقعنا في قسم "الملاحظات" الخاص بكل عربية.\n\nكمان هيكون ليك الحق كاملًا في فحص العربية بنفسك قبل اتمام عملية الشراء من خلال حجز اختبار القيادة سواء في المركز الرئيسي لسيلندر أو في المكان التحدده.',
              },
              {
                id: 2,
                q: 'إيه الإجراء لو حالة عربيتي مش زي ما أنا مقدرها؟',
                a: 'لآننا مهتمين بتوفير تجربة استخدام مثالية لعملائنا، ففي حالة عدم رضاك عن آداء العربية آو حالتها تقدر تستفيد من سياسة استرجاع سيلندر؛ واللي بتتيح لك تسترد فلوسك لو رجعت العربية خلال 7 أيام من استلامها',
              },
              {
                id: 3,
                q: 'هل ممكن أتفاوض في سعر عربيات سيلندر؟',
                a: 'سعر العربيات في سيلندر ثابت وغير قابل للتفاوض. إحنا مقتنعين بآن جميع عملائنا من حقهم الحصول على سعر ثابت طبقًا لحالة العربية بغض النظر عن مهارتهم التفاوضية أو حاجتهم للعربية، وأن من حق كل عميل لسيلندر أنه يحصل مباشرة على أفضل سعر للعربية!\n\nاحنا بنحدد سعر كل عربية اعتمادا على بيانات أسعار السوق ونتائج تقرير الفحص اللى بنجريه علشان نوصل لسعر عادل. وده بيخلي العميل يشتري العربية اللى هو عايزها وهو مطمن بأن ده أفضل سعر مقابل القيمة، لإنها معتمدة من سيلندر.',
              },
              {
                id: 4,
                q: 'إزاي أعرف إن اللي بادفعه سعر عادل؟',
                a: 'كل عربية معتمدة من سيلندر تم اختيارها بعناية، لإننا قبل اعتمادها بنجري عليها اختبار فحص ال200 نقطة علشان نطمن إنها في حالة ممتازة للقيادة. كمان احنا بنعتمد على بيانات أسعار السوق ونتائج تقرير الفحص، علشان نضمن حصول عملاءنا على سعر عادل ومحدد غير قابل للتفاوض.\n\nولو إنت مش مبسوط من العربية اللى اشتريتها، ممكن ترجعها خلال فترة السبع أيام من تاريخ الاستلام وتستلم 100% من قيمة العربية اللي دفعتها. إحنا كمان بنوفر ضمان لكل العربيات المباعة من سيلندر لمدة ٩٠ يوم لأن هدفنا تكون تجربة شرائك للعربية بدون أي خوف أو قلق!',
              },
            ],
          },
  
          {
            id: 2,
            topic: 'حجوزات واختبارات القيادة ',
            questions: [
              {
                id: 5,
                q: 'إزاي أحجز زيارة عشان أشوف العربية اللي أنا مهتم بيها؟',
                a: 'عشان تحجز زيارة، ببساطة تصفح موقعنا وابحث عن العربية اللي مهتم بيها. اضغط على "اطلب زيارة". بعدين هيتطلب منك تملأ بياناتك وتحدد موعد ووقت مناسب لزيارة صالة العرض.',
              },
              {
                id: 6,
                q: 'إيه المعلومات اللي لازم أقدمها عند حجز زيارة؟',
                a: 'عند حجز زيارة، لازم تقدم رقم تليفونك، وتحدد الموعد والوقت المفضل لزيارتك. المعلومات دي بتساعدنا نجهز لزيارتك ونتأكد إن العربية جاهزة تشوفها.',
              },
              {
                id: 7,
                q: 'إيه اللي بيحصل بعد ما أحجز زيارة عشان أشوف العربية؟',
                a: 'بعد ما تحجز زيارة، لازم تيجي صالة العرض في الموعد المحدد. هتكون عندك فرصة تشوف العربية وتجربها في قيادة تجريبية. لو عجبتك العربية وعايز تحجزها، تقدر تكمل عملية الحجز.',
              },
              {
                id: 8,
                q: 'إزاي أقدر أحجز العربية بعد زيارتي؟',
                a: 'لو قررت تحجز العربية بعد زيارتك، بلغ مسئول البيع اللي معاك و هو هيبعتلك رابط دفع على رقم الموبايل اللي قدمته عند الحجز. لازم تدفع رسوم حجز 10,000 جنيه عشان تحجز العربية  (١٠٠٪ تسترد في حالة الالغاء) . الحجز صالح لمدة 48 ساعة، لازم تكمل عملية الشراء خلال الفترة دي.',
              },
              {
                id: 9,
                q: 'إيه اللي بيحصل لو ما كملتش عملية الشراء خلال 48 ساعة بعد حجز العربية؟',
                a: 'لو ما كملتش عملية الشراء خلال 48 ساعة، الحجز هينتهي والعربية هتبقى متاحة للعملاء الآخرين. مهم تكمل عملية الشراء خلال الفترة دي عشان تضمن إن العربية تفضل محجوزة ليك.',
              },
            ],
          },
          {
            id: 3,
            topic: 'الشراء والتسليم',
            questions: [
              {
                id: 10,
                q: 'إيه هو شكل نقل الملكية؟',
                a: 'بعد دفع تمن العربية، هنوفر لك جواب لإدارة المرور لنقل ملكية العربية باسمك. ولتسهيل الإجراءات عليك، إحنا مسجلين سيلندر في إدارة المرور كموزع معتمد للعربيات وده بيوفر عليك مشوار نقل الملكية في مكتب الشهر العقاري.',
              },
              {
                id: 11,
                q: 'هل تكلفة نقل الملكية ضمن سعر العربية؟',
                a: 'أيوه، سعر العربية شامل تكاليف نقل الملكية. سيلندر مسجلة كموزع معتمد في إدارة المرور وده بيخلينا نوفر لك جواب للمرور بعد شراء العربية علشان تنقل الملكية وترخص العربية باسمك',
              },
              {
                id: 12,
                q: 'هل ممكن ادفع كاش؟',
                a: 'لا للأسف، لكن احنا بنقبل الإيداعات البنكية والتحويلات البنكية والشيكات البنكية كطرق دفع.',
              },
              {
                id: 13,
                q: 'هل لازم ادفع أي رسوم عن إتمام معاملة الشراء؟',
                a: 'ممكن يبقى فيه رسوم إضافية لتحويل المبلغ وده بيختلف حسب آلية الدفع والبنك اللى بتتعامل معاه. بخلاف ذلك مفيش أي رسوم بتدفعها لسيلندر لما تحجز عربيتك',
              },
              {
                id: 14,
                q: 'هل ممكن استلام عربيتي المعتمدة من سيلندر من البيت؟',
                a: 'أيوه، ممكن نوصل لك عربيتك المعتمدة من سليندر لباب البيت. الموضوع ده مرتبط بمدى توافر موظف لشحن العربية. علشان كده بنرجو منك أثناء الدفع إنك تحجز خدمة تسليم العربية بالبيت.',
              },
            ],
          },
          {
            id: 4,
            topic: 'الاستبدال',
            questions: [
              {
                id: 15,
                q: 'إيه مواصفات العربيات اللى بتوافق عليها سيلندر للاستبدال؟',
                a: 'احنا بنحاول نقبل كل العربيات ولكن اللى بيحكمنا هو حالة العربية. أغلب العربيات اللى بنوافق عليها للاستبدال عمرها أقل من 10 سنين وقراءة العداد أقل من 120 الف كم. ما بنشتريش العربيات اللى عاملة حوادث كبيرة أو فيها مشاكل وتعديلات في ميكانيكا وكهربة العربية.',
              },
              {
                id: 16,
                q: 'إزاي بتتم إجراءات الاستبدال؟',
                a: 'بمجرد ما تختار العربية اللي عايز تشتريها، بتطلب إنك تستبدل عربيتك القديمة باللي انت عايز تشتريها. بعد كده بنقوم بفحص عربيتك القديمة ونقولك السعر العادل اللى بنقدره وفقا لحالة عربيتك وسعرها الحالي في السوق. لو وافقت على السعر بنخصمه من تمن العربية المعتمدة من سيلندر اللى عايز تشتريه',
              },
              {
                id: 17,
                q: 'إمتى أسلمكم العربية لإتمام الاستبدال؟',
                a: 'في نفس اليوم اللى هنسلمك عربيتك المعتمدة من سيلندر هنستلم منك عربيتك القديمة اللى عرضتها للاستبدال',
              },
              {
                id: 18,
                q: 'هل ممكن استبدل عربيتي الحالية لو متاح لي تمويل متميز؟',
                a: 'أيوه ممكن. إحنا هنقدر تمن عربيتك حسب حالتها وسعرها في السوق وهنقارن المبلغ ده بالتمويل المتاح ليك.',
              },
              {
                id: 19,
                q: 'هل ممكن أتفاوض على السعر المعروض من سيلندر للاستبدال؟',
                a: 'أسعارنا غير قابلة للتفاوض. أحنا بنوفر لعملاءنا أسعار عادلة وتجربة شفافة بدون مفاوضات أو مساومات، لضمان أن كل عملاء سيلندر يحصلوا على أفضل عرض إحنا نقدر نوفره لشراء عربية',
              },
            ],
          },
          {
            id: 5,
            topic: 'التمويل والتأمين',
            questions: [
              {
                id: 20,
                q: 'ازاي أقدر أقدم على تمويل؟',
                a: 'تقدر تقدم اونلاين على موقعنا بعد ما تحجز عربيتك. لدينا شراكات مع عدد من مؤسسات التمويل واللي بتوفر أكتر من نظام تمويل بصورة مرنة.\n\nقبل ما تقرر، هتقدر من خلال موقعنا تحدد المقدم اللى هتدفعه، ومدة النقسيط اللي تفضلها، وإذا كنت عايز إن العربية يكون عليها حظر بيع أو لأ، وببساطة هتعرف قيمة القسط الشهري اللى عليك. أول ما تخلص الإجراءات دي على الموقع، فريقنا هيدرس الملف مع مؤسسة التمويل، وهنتواصل معاك علشان نبلغك بتطور طلب التمويل.',
              },
              {
                id: 21,
                q: 'إيه هي نسبة التمويل المسموح بيها من سعر العربية ؟',
                a: 'ممكن تحصل على تمويل لغاية 90% من تمن عربية سيلندر المعتمدة، لكن اللي بيحدد القيمة الآقصى للتمويل هو مؤسسة التمويل . بمجرد ما بتستوفي الأوراق المطلوبة، بنتواصل معاك علشان نبلغك بآخر التطورات بالنسبة للعربية اللى اخترتها وامكانية التقسيط.',
              },
              {
                id: 22,
                q: 'إيه اللي هيحصل لو حصلت على التمويل وبعد كده رجعت العربية خلال فترة ال7 أيام ضمان ؟',
                a: 'في حالة عدم رضاك عن  العربية اللي اشتريتها هتقدر ترجع العربية في فترة السبع أيام من تاريخ الاستلام وتستفيد من الضمان اللى بنوفره باسترداد فلوسك حتى لو هي في صورة تمويل. نرجو مراجعة سياسة الاسترداد الخاصة بسيلندر.',
              },
              {
                id: 23,
                q: 'إيه هي الأوراق المطلوبة للاستفادة من فرصة تمويل العربية؟',
                a: 'محتاج تحمل صورة بطاقتك على الموقع وتملا بيانات ملف طلب التمويل. بمجرد ما نراجع ملفك مع شركائنا من مؤسسات التمويل وناخد موافقتهم، هتحتاج تقدم بعض الأوراق الإضافية علشان تحصل على التمويل. ',
              },
              {
                id: 24,
                q: 'هل يمكن لسيلندر ترتيب إجراءات التمويل من أي بنك أختاره ؟',
                a: 'إحنا ما بنقبلش إلا طريقتين دفع، يا إما الدفع المباشر من العميل أو تمويل العربية عن طريق واحدة من شركائنا من مؤسسات التمويل المعتمدة من خلالنا',
              },
            ],
          },
          {
            id: 6,
            topic: 'معتمدة من سيلندر',
            questions: [
              {
                id: 25,
                q: 'يعني إيه معتمدة من سيلندر؟',
                a: 'معتمد من سيلندر هو التزام مننا بتوفير عربيات عالية الجودة لعملاءنا لجعل تجربة شراء أي عربية من عندنا سهلة ومريحة ومضمونة.\nكل عربية معتمدة من سيلندر مرت بعد تجديدها بفحص ال200 نقطة. كل عربيات سيلندر المعتمدة بيبقى عليها ٩٠ يوم ضمان شامل علشان قرارك يكون بدون أي قلق أو خوف. ولو معجبتكش العربية بعد استلامها ممكن ترجعها خلال 7 أيام من تاريخ الاستلام وتسترد فلوسك كاملة بدون أي سؤال أو نقاش من طرفنا.',
              },
              {
                id: 26,
                q: 'إيه هو نظام فحص ال200 نقطة من سيلندر؟',
                a: 'أي عربية علشان تكون معتمدة من سيلندر لازم نجري عليها اختبار فحص ال200 نقطة. الفحص بيشمل 3 حاجات:\n- الجزء الفني: فحص ميكانيكيا العربية؛ من أول المحرك والفتيس والمساعدين والفرامل لغاية أنظمة التبريد والتكييف\n- الخارجي: فحص الخدوش والكسور اللى في هيكل العربية والأجزاء المستبدلة وحالة الدهان\n- الداخلي: حالة الكراسي والفرش والزراير والسماعات بالإضافة لحاجات تانية جوه الصالون الداخلي',
              },
              {
                id: 27,
                q: 'إيه هي سياسة سيلندر لاسترداد الأموال خلال 7 أيام؟',
                a: 'ضمان استرداد الأموال لمدة 7 أيام هو التزام من سيلندر لعملاءنا إنهم ياخدوا وقتهم ويشوفوا إذا كانوا مبسوطين ومطمنين تماما بعد شراء العربية. لو شعروا بغير كده، بعد شراءهم عربية سيلندر المعتمدة من حقهم يرجعوا العربية ويستردوا فلوسهم بالكامل من غير ما نوجه لهم أي سؤال. كل اللى بنطلبه منهم هو إنهم يلتزموا بالشروط والإجراءات علشان عملية استرداد الأموال تتم وفقا لسياسة الاستخدام العادل والشروط هي كالتالي:\n1) لازم يقدم العميل طلب إرجاع العربية خلال أول 7 أيام من تاريخ تسلمها.\n2)أقصي كيلومترات عملتها العربية من تاريخ تسلمها ماتزيدش عن 250 كم.\n3) ما يكونش تم في العربية أي أعمال صيانة خارجية أو تصليح أو حصل للعربية خدوش أو كسر أو استبدال أجزاء خلال فترة صلاحية ال7 أيام لاسترداد الأموال.\n\nإذا كانت عربيتك المعتمدة من سيلندر مستوفيه المعايير اللي مكتوبة، فممكن تستفيد من ضمان استرداد 100٪ من تكلفة العربية بموجب سياسة استرداد الأموال لمدة 7 أيام. للمتابعة، اتصل بـينا على الرقم التالي: ١٧١٨٨ أو ابعتلنا إيميل على contact@sylndr.com، ووصل لنا عربيتك لمركز لسيلندر.',
              },
              {
                id: 28,
                q: 'إيه هو ضمان ال٩٠ يوم من سيلندر؟',
                a: 'ضمان ال٩٠ يوم من سيلندر\nكل عربيات سيلندر المعتمدة مضمونة لمدة ٩٠ يوم علشان نوفر متعة قيادة العربية بدون أي أعطال ميكانيكية مفاجئة. الضمان بيكون لمدة 90 يوم أو 5000 كم (أيهما أقرب) من تاريخ شراء العربية.\n\nطلب ضمان سيلندر\nلو حصل أي حاجة وعايز تستفيد بالضمان، اتصل بفريق الدعم على ١٧١٨٨ خلال الأسبوع (ما عدة الجمعة والسبت) من الساعة 9 صباحا إلى الساعة 5 مساءً أو راسلنا على contact@sylndr.com.\n\nملاحظة: برجاء التأكد من ارسال استفسارك عبر قنوات خط المساعدة اللى فوق خلال 3 أيام عمل من وقوع العطل. عدم القيام بالإجراءات دي في مواعيدها مش هيتيح لك الاستفادة بالضمان. برجاء إرسال رقم تسجيل العربية على الميل في عنوان الرسالة.\n\nشروط صلاحية الضمان\nيعتبر الضمان الخاص بعربيتك المعتمدة من سيلندر باطل في حالة الشروط التالية:\n- لو صيانة العربية ما بتتعملش في الوقت المناسب:  لو العميل ما بيعملش الصيانة الدورية للعربية في الوقت المناسب وحسب إرشادات الشركة المصنعة للعربية. يجب على العميل القيام بكل خدمات الصيانة واختبارات العربية في مركز خدمة معتمد. لازم تحتفظ بنسخة من كل إجراءات الصيانة الدورية للعربية.\n\nملاحظة: صيانة العربية بتشمل، تغيير زيت الموتور، وفلتر الزيت، وفحص مستوى الزيت في علبة التروس ومراجعة التروس، ومستوى سائل التبريد، وتزويده عند الضرورة.\n\n- التغييرات في حالة العربية:  لو تم إجراء تغييرات كبيرة في حالة العربية بشكل يأثر على أداء العربية أو حصل أي ضرر للعربية، فبيتم إلغاء الضمان. لو عايز تعرف تفاصيل أكتر نرجو مراجعة كتيب ضمان اللي تم تسليمه مع شراء العربية.\n\n- البيع لشخص آخر: الضمان على عربيتك المعتمدة من سيلندرغير قابل للتحويل ويعتبر ملغي إذا تم بيع العربية لشخص آخر قبل انتهاء صلاحية تغطية الضمان.\n\n- إستخدام تجاري:  يعتبر الضمان على عربيتك المعتمدة من سيلندر ملغي إذا تم استخدام العربية كتاكسي أو عربية للتدريب على السواقة أو أي أغراض تجارية.\n\nاستثناءات الضمان\n- الإصلاحات / الأضرار الخارجية: سيلندر مش مسؤولة عن أي تعويضات أو عن أي إصلاحات خارجية / استبدال من قبلك أو عن أي أضرار جانبية بعد تسليم العربية.\n- نقل ضمان التوكيل: يتم نقل أي ضمان من التوكيل (إذا كان ساري) إلى العربية مع ضمان سيلندر ويتم الاستفادة منه حسب شروط وأحكام ضمان التوكيل.\n\nتغطية الضمان\nللاطلاع على نظرة عامة مفصلة عن الأجزاء اللى بيغطيها الضمان، نرجو قراءة دليل تغطية الضمان (مرفق).',
              },
            ],
          },
        ],
      },
      sell: {
        featured: [
          {
            id: 'sell0',
            q: 'مين هو المشتري؟',
            a: 'سيلندر هو المشتري المباشر للعربية، ومن خلال خدماتنا هتقدر تبيع عربيتك بسهولة خلال 48 ساعة.',
          },
          {
            id: 'sell1',
            q: 'إيه العربيات اللي سيلندر بتشتريها؟',
            a:
              'سيلندر بتحافظ على قائمة شراء تحدث بانتظام:\n' +
              '\n' +
              '1) تم تصنيعها من عام ٢٠١٠ حتى الآن\n' +
              '2) عداد الكيلومترات لا يتجاوز ١٨٠,٠٠٠ كيلومتر\n' +
              '3) مسجلة باسمك\n' +
              '4) يمكننا أيضًا شراء العربيات بتوكيل إذا كنت صاحب للعربيه مباشر\n' +
              '5) العربيات الخاصة فقط؛ لا نشتري العربيات التجارية\n' +
              '6) لا نشتري العربيات الهجينة أو الكهربائية أو العاملة بالغاز الطبيعي\n' +
              '7) رخصة العربيه سارية',
          },
          {
            id: 'sell4',
            q: 'إيه هي المعلومات المطلوبة عشان احصل على تقييم لعربيتي؟',
            a: 'هنحتاج اتباع بعض الخطوات لمساعدتنا في تسعير عربيتك وهي:\n1) نوع الرخصة ومواصفات العربية\n2) فحص العربية وعمل اختبار قيادة لتقييم حالتها\n3) صور للعربية\nالمعلومات دي بتساعد فريق التسعير لتقديم أفضل عرض سعر لشراء العربية',
          },
          {
            id: 'sell7',
            q: 'هل فحص وتقييم العربية عند البيت مجاني؟',
            a: 'نعم ، التقييم مجاني تمامًا. إنت مش ملزم تدفع أي مصاريف خلال مراحل فحص وتقييم العربية. وفي حالة حدوث عكس ذلك يُرجى التواصل معنا مباشرة من خلال الرقم الساخن ١٧١٨٨',
          },
          {
            id: 'sell17',
            q: 'إيه اللى هيحصل لو بعد التقييم، غيرت رأيي في موضوع بيع العربية؟',
            a: 'هدفنا في الأساس هو إننا نوفر لكل عميل تجربة سلسة ومضمونة في بيع وشراء العربيات المستعملة. من حقك تماما ترفض تبيع عربيتك لسيلندر بعد إجراء الفحص والتقييم.',
          },
          {
            id: 'sell24',
            q: 'إيه هي إجراءات نفل الملكية؟',
            a: 'الموضوع لايتعدى 4 خطوات بسيطة كالتالي:\n1) توقيع عقد شراء سيلندر للعربية.\n2) بندفع لك الفلوس (شيك أو تحويل بنكي).\n3) بنستلم العربية من قدام بيتك.\n4) بنتقابل في مكتب الشهر العقاري علشان نخلص إجراءات نقل الملكية.',
          },
        ],
        topics: [
          {
            id: 0,
            topic: 'عامة',
            questions: [
              {
                id: 0,
                q: 'مين هو المشتري؟',
                a: 'سيلندر هو المشتري المباشر للعربية، ومن خلال خدماتنا هتقدر تبيع عربيتك بسهولة خلال 48 ساعة',
              },
              {
                id: 1,
                q: 'إيه العربيات اللي سيلندر بتشتريها؟',
                a:
                  'سيلندر بتحافظ على قائمة شراء تحدث بانتظام:\n' +
                  '\n' +
                  '1) تم تصنيعها من عام ٢٠١٠ حتى الآن\n' +
                  '2) عداد الكيلومترات لا يتجاوز ١٨٠,٠٠٠ كيلومتر\n' +
                  '3) مسجلة باسمك\n' +
                  '4) يمكننا أيضًا شراء العربيات بتوكيل إذا كنت صاحب للعربيه مباشر\n' +
                  '5) العربيات الخاصة فقط؛ لا نشتري العربيات التجارية\n' +
                  '6) لا نشتري العربيات الهجينة أو الكهربائية أو العاملة بالغاز الطبيعي\n' +
                  '7) رخصة العربيه سارية',
              },
              {
                id: 2,
                q: 'هل أنا ملزم ببيع عربيتي لسيلندر بعد إجراء الفحص؟',
                a: 'لا، أنت مش ملزم أو مرغم تبيع عربيتك لسيلندر، أولويتنا هي التأكد من حصولك على أفضل خدمة ممكنة خلال إتمام عملية البيع مع سيلندر.',
              },
              {
                id: 3,
                q: 'هل ممكن سيلندر تشتري عربيتى وأنا عندي قرض أو تمويل مستحق؟',
                a:
                  'نعم، ممكن. سيلندر هتدفعلك ٥٠٪ من سعر العربية مقدمًا، وسيتم دفع الباقي بالكامل بعد رفع حظر البيع.\n' +
                  '\n' +
                  '1) يجب عليك توفير توكيل رسمي\n' +
                  '2) نقدم للعملاء المحتملين فترة سماح تقريبًا شهر من تاريخ البيع',
              },
              {
                id: 4,
                q: 'إيه هي المعلومات المطلوبة عشان احصل على تقييم لعربيتي؟',
                a: 'هنحتاج اتباع بعض الخطوات لمساعدتنا في تسعير عربيتك وهي:\n1) نوع الرخصة ومواصفات العربية\n2) فحص العربية وعمل اختبار قيادة لتقييم حالتها\n3) صور للعربية\nالمعلومات دي بتساعد فريق التسعير لتقديم أفضل عرض سعر لشراء العربية',
              },
            ],
          },
          {
            id: 1,
            topic: 'حجز موعد',
            questions: [
              {
                id: 5,
                q: 'أيه الاماكن المتاحة لحجز زيارة فحص؟',
                a: 'تقدر تزورنا في مركز فحص سيلندر، أو نجيلك في المكان اللي تختاره.',
              },
              {
                id: 6,
                q: 'هل فحص وتقييم العربية عند البيت مجاني؟',
                a: 'نعم، التقييم مجاني تمامًا. أنت مش ملزم تدفع أي مصاريف خلال مراحل فحص وتقييم العربية.',
              },
              {
                id: 7,
                q: 'عربيتى مش موجودة في قائمة سيلندر. أعمل ايه؟',
                a: 'إذا لم تكن عربيتك متاحة حاليًا، بسبب عدم توافقها لمعايير الشراء الحالية لدى سيلندر. نقوم بتحديث معاييرنا بانتظام، لذا يرجى زيارة موقعنا بشكل متكرر لمتابعة أي تحديث.',
              },
              {
                id: 8,
                q: 'هل ممكن ألغي أو اختار معاد تاني لفحص عربيتي؟',
                a: 'لو الوقت مش مناسب، ممكن تتواصل مع فريق دعم العملاء وتلغي المعاد أو تحدد معاد تاني من خلال التواصل على ١٧١٨٨ وفريق سيلندر هيقدملك كل المساعدة.',
              },
            ],
          },
          {
            id: 2,
            topic: 'الفحص',
            questions: [
              {
                id: 9,
                q: 'إزاي هيتم فحص عربيتي؟',
                a: 'من خلال فريق متخصص من الخبراء التقنيين لفحص العربيات، وبيتكون من مهندسين عربيات من ذوي الخبرة و استخدام أحدث التقنيات والأدوات الحديثة لإعداد تقرير الفحص التفصيلي عن كل عربية بنفحصها.',
              },
              {
                id: 10,
                q: 'إيه الأوراق اللي محتاج أقدمها لفحص عربيتي؟',
                a: 'كل اللي بنحتاجه رخصة سارية للعربية، غير بعض الأوراق اللى هتوفرها بمجرد ما توافق على عرض البيع اللى بنقدمهولك وبنبدأ إجراءات نقل الملكية.',
              },
              {
                id: 11,
                q: 'هل هتشاركوني نتائج تقرير الفحص؟',
                a: 'لا يتم الإعلان عن نتائج تقرير الفحص، حيث تم تطويرها فقط للاستخدام الداخلي لفريق سيلندر.',
              },
              {
                id: 12,
                q: 'إيه اللي هيتم مراجعته في العربية خلال إجراءات الفحص؟',
                a: 'الفحص اللى بنجريه على العربية بيكون تقييم مفصل بيغطي أكثر من 200 نقطة بيشملوا الهيكل الخارجي والداخلي وكفاءة العربية والاطمئنان إن مافيهاش أي أعطال أو عيوب فنية. بعد الفحص، الخبراء الفنيون في سيلندر بيعملوا اختبار قيادة لتقييم حالة العربية، وبيصوروا العربية والرخصة.',
              },
              {
                id: 13,
                q: 'إيه اللي بيتم بعد إتمام الفحص؟',
                a: 'بعد ما خبراءنا الفنيين يكتبوا التقرير بيشاركوه مع فريق التسعير، وفي خلال 24 ساعة بنتصل بيك ونقول لك على عرض السعر.',
              },
            ],
          },
          {
            id: 3,
            topic: 'التقييم',
            questions: [
              {
                id: 14,
                q: 'إيه ضمانات سيلندر لبيع عربيتي بأفضل سعر؟',
                a: 'إحنا في سيلندر بنؤمن أنك تستحق سعر عادل لعربيتك حسب حالتها الحالية، علشان كده بنقدم خدمة فحص العربية مجانًا في البيت علشان نسهل عليك إجراءات تسعير وبيع العربية مباشرة وانت قاعد في البيت. الإجراء ده بنوفره من غير تدخل وسطاء علشان نوفر لك أفضل سعر لبيع عربيتك.',
              },
              {
                id: 15,
                q: 'بتحتاجوا وقت قد إيه لتقييم عربيتي؟',
                a: 'تقييمنا يستغرق حد أقصى ٢٤ ساعة لإكماله وإبلاغك بعرض السعر.',
              },
              {
                id: 16,
                q: 'هل تقييم عربيتي يعني إنكوا بتضمنوا بيعها؟',
                a: 'الفحص اللى بنعمله بيساعد في تقدير سعر عادل وحقيقي لعربيتك، لكنه مش بيضمن إننا في سيلندر هنشتري منك العربية. لو تقرير الفحص مش متماشي مع معاييرنا في اختيارالعربيات للآسف مش بنقدر نشتري العربية.',
              },
              {
                id: 17,
                q: 'إيه اللي هيحصل لو بعد التقييم، غيرت رأيي في موضوع بيع العربية؟',
                a: 'هدفنا في الأساس هو إننا نوفر لكل عميل تجربة سلسة ومضمونة في بيع وشراء العربيات المستعملة. من حقك تمامًا ترفض تبيع عربيتك لسيلندر بعد إجراء الفحص والتقييم.',
              },
              {
                id: 18,
                q: 'إيه هي مدة صلاحية عرض سيلندر؟',
                a: 'إحنا مش عايزينك تستعجل في اتخاذ القرار، علشان كده خلينا مدة صلاحية العرض اللى بنقدمة 24 ساعة من وقت ابلاغك بعرض السعر ولازم كمان تكون العربية مامشيتش أكثر من 350 كم من ساعة الفحص. من حقك طبعا تتصل بينا بعد 24 ساعة وتبلغنا بموافقتك على عرض السعر، بس ده هيتطلب فحص وتقييم العربية من جديد.',
              },
            ],
          },
          {
            id: 4,
            topic: 'الدفع',
            questions: [
              {
                id: 20,
                q: 'إيه أقرب وقت لاستلام تمن العربية؟',
                a: 'بمجرد ما توقع عقد البيع، بنسلمك الشيك أو بنحول لك الفلوس على حسابك في البنك. بالنسبة للشيكات، لما بتوديه للبنك اللى بتتعامل معاه الموضوع بياخد ما بين يوم لـ 3 أيام عمل علشان الفلوس تتحول لحسابك. ( لو الشيك صادر من حساب في نفس البنك اللى بتتعامل معاه التحويل بيتم في يوم، لو البنكين مختلفين التحويل بيتم في 3 أيام). لو التحويل أونلاين عن طريق الإنترنت، الفلوس بتدخل حسابك خلال يوم عمل.',
              },
              {
                id: 21,
                q: 'إيه هي طرق الدفع المتاحة من سيلندر؟',
                a: 'طرق الدفع عندنا هي: شيك بنكي، شيك عادي، تحويل أونلاين لحسابك في البنك. إحنا حريصين على توفير أكتر من وسيلة مناسبة لدفع تمن العربية.',
              },
              {
                id: 22,
                q: 'تحويل الفلوس لحسابي بياخد وقت قد إيه؟',
                a: 'لو التحويل أونلاين عن طريق الإنترنت، الفلوس بتدخل حسابك خلال يوم عمل.',
              },
              {
                id: 23,
                q: 'هل الدفع بيتم قبل ولا بعد استلام سيلندر للعربية؟',
                a: 'الدفع بيتم بعد توقيع عقد البيع ولكن قبل نقل الملكية في الشهر العقاري.',
              },
            ],
          },
          {
            id: 5,
            topic: 'نقل الملكية وتسليم العربية',
            questions: [
              {
                id: 24,
                q: 'إيه هي إجراءات نفل الملكية؟',
                a: 'الموضوع لايتعدى 4 خطوات بسيطة كالتالي:\n1) توقيع عقد شراء سيلندر للعربية.\n2) بندفع لك الفلوس (شيك أو تحويل بنكي).\n3) بنستلم العربية من قدام بيتك.\n4) بنتقابل في مكتب الشهر العقاري علشان نخلص إجراءات نقل الملكية.',
              },
              {
                id: 25,
                q: 'إيه اللى محتاج أجيبه معايا وأنا بسلم العربية؟',
                a: 'بنحتاج الحاجات دي واحنا بنستلم العربية:\n1) مفاتيح العربية والسبير (النسخة الاحتياطي)\n2) رخصة العربية والتوكيل لو متوفر\n3) شهادة الضمان وإيصالات الصيانة لو متوفرة.\n4) طفاية الحريق، شنطة الإسعافات والمثلث ومستلزمات المرور لو متوفرة',
              },
              {
                id: 26,
                q: 'نقل الملكية من اسمي للمشتري الجديد بياخد وقت قد إيه؟',
                a: 'إحنا بنسهل إجراء نقل الملكية من خلال مكتب الشهر العقاري. فريق المعاملات عندنا هيساعدك علشان تتم عملية البيع بسهولة وبدون أي متاعب ليك.',
              },
              {
                id: 27,
                q: 'إمتى لازم أسلم العربية؟',
                a: 'بمجرد ما تمضي العقد مع سيلندر، وتستلم كل فلوسك عن بيع العربية.',
              },
              {
                id: 28,
                q: 'اتصل ازاي بسيلندر لأي استفسارات بعد البيع ؟',
                a: 'يسعدنا تتواصل مع فريق خدمة العملاء لسيلندر على الرقم ده ١٧١٨٨ وهنرد على كل أسئلتك واستفساراتك.',
              },
            ],
          },
        ],
      },
    },
  };
  
